<template>
  <div class="indexModule ad3" :data="moduleData.Guid">
    <div class="area-market-ad ad3">
        <div class="head-title">
            <!-- <div class="adheadLeft">
                <img src=" ../../../static/ad1.png" alt="">
            </div>   新年样式        -->
            <div class="adheadMiddle">
               <span class="text" :style="{borderLeft :'2px solid '+ floorData.Color ,borderRight:'2px solid '+ floorData.Color}">{{floorData.FloorName}}</span>
            </div>
            <!-- <div class="adheadRight">
                <img src=" ../../../static/ad3.png" alt="">
            </div>            -->
        </div>
        <div class="ad-list" v-for="mItem in floorData.AdList">
			<div class="ad-item">
			<a :href="mItem.Link ? mItem.Link : '/#/retail/productlist?bannerImg=' + mItem.Img + '&FloorName=' + floorData.FloorName">
				<div>
					<img :src="mItem.Img" class="ad-img" />
				</div>
				<span class="text-info">
				<span class="name" :style="{color:mItem.Color}">{{mItem.Text}}</span>
				<span class="desc" :style="{color:mItem.Color2}" v-if="mItem.Desc">——{{mItem.Desc}}</span>
				</span>
				<span class="bottom-logo">
					<img src="/static/index/bottom-logo.png" />
				</span>
			</a>
			</div>
		</div>            
        </div>
    </div>
</div>

</template>

<script>
export default {
  name:'XR-mobile-ad3',
  data() {
    return {
      adHeight: document.documentElement.clientWidth /1.77
    }
  },
  props:{
      guid:'',
      configData:{}
  },
  computed:{
    moduleData:function(){
        for(var i=0; i < this.configData.Modules.length;i++){
            var moduleItem = this.configData.Modules[i];
            if(this.guid == moduleItem.Guid){
                return moduleItem;
            }
        }
        return {}
    },
    floorData:function(){
        for(var i = 0; i< this.configData.Floors.length;i++){            
            var floorItem =this.configData.Floors[i];
            if(this.guid == floorItem.Guid){
                return floorItem;
            }
        }
        return {}
    }
  }
}
</script>

<style>
    .ad3 .btn-list {
        position:absolute;
        top:50%;
        left:15%;
        z-index:999;
        display:none;
    }
    .area-market-ad.ad3 {
        width:100%;
        position:relative;
    }
    .area-market-ad.ad3  .head-title {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 18px 0 18px;
        background:#EFEFEF;
    }

    .area-market-ad.ad3  .head-title .adheadLeft{
        width: 33%;
        text-align: right;
    }
    .area-market-ad.ad3  .head-title .adheadLeft img{
        width: 30px;
    }
    .area-market-ad.ad3  .head-title .adheadMiddle{
        width: 34%;
        text-align: center;
    }
    .area-market-ad.ad3  .head-title .adheadRight{
        width: 33%;
        text-align: left;
    }
     .area-market-ad.ad3  .head-title .adheadRight img{
        width: 30px;
    
    }

    .area-market-ad.ad3 .head-title .icon {
        vertical-align: middle;
        height: 40px;
    }

    .area-market-ad.ad3 .head-title .text {
        vertical-align: middle;
        font-size: 18px;
        border-left:2px solid #333;
        border-right:2px solid #333;
        padding:0 10px;
        color:Black;
    }

    .area-market-ad.ad3 .head-title .desc {
        vertical-align: sub;
        font-size: 12px;
        border-left: 1px solid red;
        padding-left: 8px;
        margin-left: 5px;
        color: #999;
    }
    .area-market-ad.ad3 .ad-list {
		width:100%;
		height:auto;
		overflow:hidden;
		margin-bottom:30px;
	}
	.area-market-ad.ad3 .ad-list .ad-item {
		width:100%;
		height:auto;
		display:inline-block;
	}
	.area-market-ad.ad3 .ad-list .ad-item div{
		height:auto;
	}
	.area-market-ad.ad3 .ad-list .ad-item .text-info{
		width:100%;
		height:auto;
		background:#fff;
		margin-bottom:8px;
		text-align:left;
		overflow:hidden;
		display: inline-block;
		white-space: nowrap;
		text-overflow:ellipsis;
		padding:12px;
	}
	.area-market-ad.ad3 .ad-list .ad-item .text-info .name {
		width:auto;
		font-size:16px;
	}
	.area-market-ad.ad3 .ad-list .ad-item .text-info .desc {
		width:auto;
		font-size:16px;
	}
	.area-market-ad.ad3 .ad-list .ad-item .ad-img{
		width:100%;
		min-height:80px;
	}
	
	.area-market-ad.ad3 .ad-list .ad-item .bottom-logo{
		width:100%;
		height:auto;
		display:inline-block;
		display:inline-block;
	}
	.area-market-ad.ad3 .ad-list .ad-item .bottom-logo img{
		width:100%;
		height:auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/index/mobile/ad3/ad3.vue